import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Image from "../../components/CustomImage";
import { getImageUrl } from "../../services/image";
import Head from "next/head";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Index = function Index() {
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: "Verblijf op maat in Engeland Ierland Schotland of Wales - Cottage Centre Vakantiehuizen en Campers"
      }), /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "initial-scale=1.0, width=device-width"
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: "Verblijf op maat Engeland, Schotland, Wales of Ierland via Cottage Centre"
      })]
    }), /*#__PURE__*/_jsxs("section", {
      className: "hero py-6 py-lg-7 text-white dark-overlay",
      children: [/*#__PURE__*/_jsx(Image, {
        src: getImageUrl('op-maat2.jpg'),
        alt: "",
        className: "bg-image",
        loading: "eager",
        layout: "fill",
        priority: true
      }), /*#__PURE__*/_jsx(Container, {
        className: "overlay-content",
        children: /*#__PURE__*/_jsx("h1", {
          className: "hero-heading",
          children: "Een verblijf op maat"
        })
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: "py-3",
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsxs("blockquote", {
          className: "blockquote blockquote-primary bg-gray-100 p-5",
          children: [/*#__PURE__*/_jsx("h2", {
            children: "Een verblijf op maat"
          }), /*#__PURE__*/_jsx("p", {
            children: "U heeft iets speciaals op de planning of in gedachten en zoekt hiervoor de perfecte of unieke locatie. Ook dan bent u bij Cottage Centre aan het juiste adres."
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "py-4",
          children: [/*#__PURE__*/_jsx("h2", {
            className: "mb-3 text-primary",
            children: "Bruiloft, familiefeest of een bijzonder teamuitje?"
          }), /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              children: [/*#__PURE__*/_jsx("p", {
                children: "Met grote regelmaat worden nieuwe cottages toegevoegd aan onze collectie. Maar mocht u op zoek zijn naar iets speciaals dat u op de website niet kunt vinden, laat het ons weten en wij vinden het voor u. Met veel unieke locaties hebben wij directe contacten waardoor u een beleving op maat kunt samenstellen."
              }), /*#__PURE__*/_jsx("p", {
                children: "Een sprookjeskasteel voor een bruiloft bijvoorbeeld? Of een gave groepslocatie voor een bedrijfsuitje waarbij u met een landrover van het vliegveld wordt gehaald. Of wat dacht u van een eigen landhuis met een landingsbaan zodat u met de helikopter uw entree kunt maken? Of een groot landhuis met een eigen golfterrein?"
              }), /*#__PURE__*/_jsx("p", {
                children: "Bekijk hier een aantal van de opties die wij bieden. En nogmaals.. benader ons gerust als u specifieke wensen heeft en wij kunnen de juiste contacten leggen."
              }), /*#__PURE__*/_jsx("h3", {
                className: "h5",
                children: "Contact opnemen?"
              }), /*#__PURE__*/_jsxs("p", {
                children: ["Bekijk ", /*#__PURE__*/_jsx("a", {
                  className: "font-weight-bold",
                  href: "/contact",
                  children: "onze contactpagina"
                }), " om te zien hoe u ons kunt bereiken."]
              })]
            })
          })]
        })]
      })
    })]
  });
};

export var __N_SSG = true;
export default Index;